import React, { StrictMode, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import DigitalSignatureComponent from "./digital-signature";
import { SignatureTranslations } from "./translations";

async function postSignature(url: string, content: string, mediaLibraryId: number): Promise<string> {
    const result = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({ content, mediaLibraryId }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then<{ fileGuid: string }>(res => res.json())

    return result.fileGuid
}

type SignatureAppProps = {
    url: string,
    mediaLibraryId: number,
    processed: boolean, onData: (data: string | undefined) => void,
    translations: SignatureTranslations
}

const SignatureApp: React.FC<SignatureAppProps> = ({ url, mediaLibraryId, onData, processed: propsProcessed, translations }) => {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [processed, setProcessed] = useState(propsProcessed)

    function process(data: string | undefined) {
        setLoading(true)
        setProcessed(false)

        if (!data) {
            console.error('didn\'t get any signature data')
            return
        }

        postSignature(url, data, mediaLibraryId)
            .then(guid => {
                setProcessed(true)
                onData(guid)
            })
            .catch(err => {
                alert(translations.somethingWentWrong)
                console.error('postSignature err', err)
            })
            .finally(() => setLoading(false))
    }

    return (
        <div className="signature-app">
            <button className="btn btn-primary sign-button" type="button" onClick={() => setOpen(true)} disabled={loading}>{!processed ? translations.signAndConfirm : translations.signAgain}</button>
            {loading && <div>{translations.processing}...</div>}
            {processed && <div>{translations.successfullyAdded}</div>}
            <Modal show={open} onClose={() => setOpen(false)} onHide={() => setOpen(false)} dialogClassName="signature-dialog">
                <DigitalSignatureComponent key={`${open}`} onData={(data) => { setOpen(false); process(data) }} onClose={() => setOpen(false)} translations={translations} />
            </Modal>
        </div>
    )
}


function renderSignature(elementId: string, inputId: string, url: string, mediaLibraryId: number, translations: SignatureTranslations) {
    function onData(data: string | undefined) {
        const element: HTMLInputElement = document.getElementById(inputId) as HTMLInputElement;
        if (element) {
            element.value = data || ''
            element.dispatchEvent(new Event('change'))
        }
    }

    const hasValue = (document.getElementById(inputId) as HTMLInputElement)?.value?.length > 0

    const element: HTMLElement = document.getElementById(elementId) as HTMLElement;
    if (element != null) {
        ReactDOM.render(<StrictMode>
            <SignatureApp onData={onData} url={url} mediaLibraryId={mediaLibraryId} processed={hasValue} translations={translations} />
        </StrictMode>, element);
    }
}

declare global {
    interface Window { renderSignature: any; }
}

window.renderSignature = renderSignature;